export type SailTypeName = 'headsail' | 'mainsail' | 'downwind';

/**
 * Maps a sailId to a sailType.
SailId	SailCategoryName
1	Main
3	Head Sail
5	Code Zero
6	Downwind Sail
7	Downwind Sail
8	Downwind Sail
 */
export const getSailTypeName = (sailId: number): SailTypeName => {
    const HEADSAIL_IDS = [3]; // sail IDs for headsails
    const MAINSAIL_IDS = [1]; // sail IDs for mainsails
    const DOWNWIND_IDS = [5, 6, 7, 8]; // sail IDs for downwind sails

    if (HEADSAIL_IDS.includes(sailId)) return 'headsail';
    if (MAINSAIL_IDS.includes(sailId)) return 'mainsail';
    if (DOWNWIND_IDS.includes(sailId)) return 'downwind';

    console.warn(`Unknown sailId: ${sailId}, defaulting to 'headsail'`);
    return 'headsail'; // Default case to prevent crashes
};
